'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _getUTMFirst = require('../cookie/getUTMFirst');

var _getUTMFirst2 = _interopRequireDefault(_getUTMFirst);

var _getUTMLast = require('../cookie/getUTMLast');

var _getUTMLast2 = _interopRequireDefault(_getUTMLast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUTMParams() {
    var utmFirst = (0, _getUTMFirst2.default)();
    var utmLast = (0, _getUTMLast2.default)();

    return (0, _extends4.default)({}, utmFirst, utmLast ? Object.keys(utmLast).reduce(function (result, key) {
        return (0, _extends4.default)({}, result, (0, _defineProperty3.default)({}, key + ' [last touch]', utmLast[key]));
    }, {}) : null);
}

exports.default = getUTMParams;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/~/rp-analytics/lib/utils/utm/getUTMParams.js
// module id = 493
// module chunks = 0